var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessGrowthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8579",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8579",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAC6UlEQVR4nO2dS3LbMBBEiZQP5NzGS8cr3yDXzIGSdDazYCkiiM8M0DD6VXljDYZgP5KSgIXSIZoAgIi+3yKainYkhAwJEXsD4AeAP7hg9vy24k6GhAwEwMcTGf/JmT3PLbi4M/4C+JSQweRk2OsSMoo7GVYjISMokWF1EhJNqQyrlZBIamRYvYREUSvDxkhIBC0ybJyEeNMqw8ZKiCc9Mmy8hHjRK8N6SIgHHjKsj4T04iXDeklID54yrN++QgC8AXjrGH+1hP7R0XNPIQDeAfy2v/eG8e4ytuXJY6b2k5DrY2prLsIsDlQyHMnIKApWMhzJPPOL3gcy4/WeUUvuyi656nVnONIbeK+Mh3H7fIx9Rs1jJlPb9ZiSEKPlyr4Y03RnnHpWCfmSAltk3IxtkmH99hbSIyPTY9ja1JcSAsePpuhcWjn12VOIp4xTz67FR+uxnxAQf0/YTgizjONYTEjvIwELLGcsIwSb7EcsIQQb7UfQC7kIszhQbxnRgVELycgoCtZbhvWkCniYEJDuR7AFPEQIiPcj2AIOF9IbeKQMOzZVwKFCQLAfUTBHqoDDhIBkP6JgnlQBhwhpkXEzNkSGHY8qYHchPTIyPcL2sFevv2s2fT+CLbBpQjxlnHpWLz6yBTZFCIjWltgCGy6ESYbNhyqwoULYZNicqAIbJoRRhs2LKrAhQlhl2NyoAgsX0iuj6QqogC2w0PpeGS0TrIUqsMh6DxktE6yFJrDIei8ZLROM7r9cvacMihNaud5bxvQTWrk+QsbUE1q5PkrGtBNauR7A9ycy3LZN6QNgrAfw8/Q/12/gSwTAWG9StIc9uT49vPiaUvp116SGx0mllNJVreqP4+Vh8K2M2gOKOvQLO2RICBkSQoaEkCEhZEgIGRJCxou+V3ChO4QMCSFDQsiQEDIkhAwJIUNCyJAQMiSEDAkhQ0LIkBAyJIQMCSFDQsiQEDIkhAwJIUNCyJAQMiSEDAkhQ0LI+AdRZWmPx8vclwAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessGrowthIcon);
export default __webpack_public_path__ + "static/media/BusinessGrowthIcon.757c32f89c76beb7c462c701fa8874d9.svg";
export { ForwardRef as ReactComponent };